import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import classnames from "classnames";
import RadioIcon from "../Components/radioIcon";


class Nps extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tmp: 0,
    };

    this.setValue = this.setValue.bind(this);
  }

  setValue(value){
    const microTime = getCurrentMicroTime(this.props.startTime);

    const detail = {
      microTime,
      value,
    };

    this.props.onDetailsUpdated([detail]);
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if (question.required && details.length === 0){
      validate.errors.push(validationTexts.required)
    }

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  render(){
    const {details} = this.props;
    const detail = details[0] || false;

    let elements = [];
    for(let i = 0; i <= 10; i++){
      elements.push(i);
    }

    return (
        <div className="box p-1">
          {elements.map(value => {
            const checked = detail && parseInt(detail.value) === parseInt(value);

            return <div
              key={'nps-' + value}
              className={classnames({
                'cafetery-wrap d-block d-md-flex flex-md-column align-items-center col w-100 p-2': true,
                'active': checked,
              })}
              onClick={() => this.setValue(value)}
            >
              <div
                  className="content text-center order-1 order-md-0" dangerouslySetInnerHTML={{__html: value}} />
            </div>
          })}
        </div>
    )
  }
}

Nps.propTypes = {
  question: PropTypes.shape({
    required: PropTypes.bool.isRequired,

  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    microTime: PropTypes.number.isRequired,
  }).isRequired),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    required: PropTypes.string
  }),
};

export default connect((state) => {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}, null, null, {withRef: true, forwardRef: true})(Nps);